import { UITypes } from 'LibNeo'

export enum MessageType {
	DANGER = UITypes.DANGER,
	PRIMARY = UITypes.PRIMARY,
	WARNING = UITypes.WARNING,
	PASSIVE = UITypes.PASSIVE,
}

export class BgMessage {
	public type: MessageType | null
	public title: string
	public message: string

	public hideIcon?: boolean

	public constructor(
		type: MessageType | null,
		payload: {
			title: string
			message: string
			hideIcon?: boolean
		}
	) {
		this.type = type
		this.message = BgMessage.getStringifyMessage(payload.message)
		this.title = payload.title
		this.hideIcon = payload.hideIcon
	}

	private static getStringifyMessage(message: unknown): string {
		if (!message) return ''
		if (typeof message === 'string') return message
		const stringify = JSON.stringify(message)
		return stringify.substring(1, stringify.length - 1)
	}
}
